// Mirrors CAMPAIGN_TRIGGERS in parceldaily-api constants/campaign.ts
export const CAMPAIGN_TRIGGERS = {
  TOPUP: "TOPUP",
};

export const CAMPAIGN_TRIGGER_LABELS = {
  [CAMPAIGN_TRIGGERS.TOPUP]: "Online Top-up",
};

// Admin form only: which voucher reward a campaign uses. The API stores either the PD-2572 `vouchers`
// list or `voucherPackages`, never both.
export const VOUCHER_REWARD_MODES = {
  PACKAGES: "packages",
  LIST: "list",
};
